import { Injectable } from '@angular/core';
import { Reservation, PAYED_BY_CARD,
    PAYED_BY_ENROLLMENT, PAYED_PER_LESSON } from '../../entities/reservation';

@Injectable()
export class ReservationUtilService {
    public getReservationBadgeStyle(status: String): String {
        switch (status) {
            case 'NEW':
                return 'badge-success';
            case 'ATTENDED':
                return 'badge-info';
            case 'NO_SHOW':
            case 'WAITING_FOR_PAYMENT':
                return 'badge-danger';
            case 'CANCELLED':
                return 'badge-warning';
            case 'LESSON_CANCELLED':
                return 'badge-primary';
            default:
                return 'badge-dark';
        }
    }

    public belongsToProduct(reservation: Reservation) {
        let product: string = this.getPaymentMethod(reservation);
        return product === PAYED_BY_CARD || product === PAYED_BY_ENROLLMENT;
    }

    public getPaymentMethod(reservation: Reservation) {
        let product: string;

        if (reservation.belongsToCard) {
            return PAYED_BY_CARD;
        }

        return PAYED_PER_LESSON;
    }

    public getPayedByProductIcon(): string {
        return 'fa fa-check';
    }

    public getNotPayedByProductIcon(): string {
        return 'fa fa-times';
    }

    public isPayedOnLine(reservation: Reservation) {
        return reservation && reservation.backofficeSessionId != null;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation.util.service.ts